import { useI18nFeedback } from '@/hooks/useI18nFeedback';
import { Translation } from '@/hooks/useTranslation';
import { Button, Box, Grid, Text, useTheme } from '@simplywallst/ui-core';
import InformationSolid from '@simplywallst/ui-core/icons/InformationSolid';

export function I18nDisclaimer() {
  const theme = useTheme();
  const makeFeedbackDrawer = useI18nFeedback();

  return (
    <Box
      paddingTop="x2spacePx"
      paddingBottom="x2spacePx"
      paddingLeft="x4spacePx"
      paddingRight="x4spacePx"
      backgroundColor="noir"
      borderRadius="x1spacePx"
      marginBottom="x2spacePx"
      style={{
        background: `${theme.color.chart05RGBA(0.3)} `,
      }}
    >
      <Grid gap="10px" templateRows="auto" templateColumns="16px auto">
        <Grid>
          <InformationSolid fill="#fff" opacity={0.5} />
        </Grid>
        <Grid>
          <Text typography="small">
            <Translation i18nKey="page.companyReport.experimentDisclaimer">
              The translation of this page is experimental and under
              development. We welcome your
              <Button styleType="strongLink" onClick={makeFeedbackDrawer}>
                feedback
              </Button>
              !
            </Translation>
          </Text>
        </Grid>
      </Grid>
    </Box>
  );
}
